import styles from "./dot.module.css";
import DotsImg from "../../../assets/imgs/dots.png";

export default function Dot2294() {
  return (
    <div className={styles.dot2294}>
      <img src={DotsImg} alt="circular-dots" />
    </div>
  );
}
